// @flow

export const computeOfferPrice = (offer: Object): Object => {
  const price = {
    dutyFreeAmount: offer?.plan?.price?.dutyFreeAmount || 0,
    taxIncludedAmount: offer?.plan?.price?.taxIncludedAmount || 0,
  };
  offer.options.forEach(option => {
    price.dutyFreeAmount += option?.price?.dutyFreeAmount || 0;
    price.taxIncludedAmount += option?.price?.taxIncludedAmount || 0;
  });

  return price;
};
